<template>
  <div class="container">
    <h2 class="title bold title-line">AVISO DE PRIVACIDAD</h2>
    <p class="text">
      Yonekawa y Asociados, S.A. de C.V., con domicilio en Av. Platanales No.
      229, Col. Nueva Santa María, Delegación Azcapotzalco, México, D.F., C.P.
      02800 en cumplimiento a lo dispuesto en la Ley Federal de Protección de
      Datos Personales en Posesión de los Particulares, hace de su conocimiento
      que se encuentra comprometido a resguardar su información personal así
      como a no vender, alquilar, compartir o divulgar su información personal a
      terceros con fines ilícitos o contrarios para lo cual fueron recabados.
    </p>
    <p class="text">
      Yonekawa y Asociados, S.A. de C.V., y/o nuestras empresas filiales y/o
      aquellos terceros que, por la naturaleza de sus trabajos o funciones
      tengan la necesidad de tratar y/o utilizar sus datos personales, utilizará
      su información para:
    </p>
    <ul>
      <li class="text">
        Proveer nuestros servicios como Agencia Aduanal y servicios integrales
        relacionados al despacho de mercancías.
      </li>
      <li class="text">
        Darle aviso sobre los posibles cambios en materia aduanal que pudiera
        afectar la operación de sus despachos.
      </li>
      <li class="text">
        Darle información sobre algún nuevo servicio que podamos ofrecerle.
      </li>
      <li class="text">
        Dar cumplimiento a obligaciones contraídas con las autoridades
        competentes en materia aduanal.
      </li>
      <li class="text">Evaluar la calidad de nuestros servicios.</li>
    </ul>
    <p class="text">
      Para las finalidades señaladas en el presente aviso de privacidad, podemos
      recabar sus datos personales de manera directa cuando usted mismo nos los
      proporciona por diversos medios con objeto de que le prestemos un
      servicio. Los datos que obtenemos por este medio pueden ser, entre otros:
    </p>
    <ul>
      <li class="text">Copia del Acta Constitutiva.</li>
      <li class="text">Copia del Poder Notarial.</li>
      <li class="text">
        Copia de la Credencial de Elector Legible del apoderado legal.
      </li>
      <li class="text">
        Copia de la Cédula Fiscal de la Empresa Importadora/Exportadora.
      </li>
      <li class="text">Copia del R-1 o en su caso del R-2.</li>
      <li class="text">Copia del comprobante de domicilio actual.</li>
    </ul>
    <p class="text">
      Es importante informarle que no le son requeridos datos considerados como
      sensibles por la Ley Federal de Protección de Datos Personales en Posesión
      de los Particulares.
    </p>
    <p class="text">
      Con la entrega de sus datos e información usted estará aceptando de manera
      tácita y lícita los términos y las condiciones contenidas en este Aviso de
      Privacidad, así como otorgando su consentimiento para el uso de esos datos
      en los términos aquí especificados, salvo que de manera expresa limite
      dicho uso.
    </p>
    <p class="text">
      Dicha Información será tratada con absoluta confidencialidad y será
      debidamente almacenada y posteriormente eliminada una vez concluida
      nuestra relación laboral y habiendo transcurrido los plazos de resguardo
      de información a que nos obligan diversas disposiciones jurídicas.
    </p>
    <p class="text">
      Usted tiene derecho de acceder a sus datos personales que poseemos y a los
      detalles del tratamiento de los mismos, así como a rectificarlos en caso
      de ser inexactos o incompletos; cancelarlos cuando considere que no se
      requieren para alguna de las finalidades señaladas en el presente aviso de
      privacidad, o cuando estén siendo utilizados para finalidades no
      consentidas o haya finalizado la relación laboral o de servicio, o bien,
      oponerse al tratamiento de los mismos para fines específicos. En todo
      momento, usted podrá revocar el consentimiento que nos ha otorgado para el
      tratamiento de sus datos personales por escrito a fin de que dejemos de
      hacer uso de los mismos.
    </p>
    <p class="text">
      Los mecanismos que se han implementado para el ejercicio de dichos
      derechos son a través de la presentación de la solicitud respectiva por
      escrito a nuestro domicilio y con copia al correo electrónico de
      <a href="mailto:">angelicafinanzas@yonekawayasociados.com</a>
    </p>
    <p class="text">Su solicitud deberá contener la siguiente información:</p>
    <ul>
      <li class="text">
        El nombre del titular y domicilio u otro medio para comunicarle la
        respuesta a su solicitud;
      </li>
      <li class="text">
        Los documentos que acrediten la identidad o, en su caso, la
        representación legal del titular;
      </li>
      <li class="text">
        La descripción clara y precisa de los datos personales respecto de los
        cuales se busca ejercer alguno de los derechos mencionados;
      </li>
      <li class="text">
        Cualquier otro elemento o documento que facilite la localización de los
        datos personales;
      </li>
      <li class="text">
        Motivo por el cual se revoca el consentimiento para el tratamiento de
        sus datos personales.
      </li>
    </ul>
    <p class="text">
      El plazo para atender su solicitud será de un máximo de veinte días,
      contados desde la fecha en que se recibió la solicitud, como lo marca el
      Artículo 32 de la Ley Federal de Protección de Datos Personales en
      Posesión de los Particulares y podrá ser ampliado siempre que se cuente
      con una jurisdicción de las circunstancias. Para mayor información, favor
      de escribir al correo electrónico de
      <a href="mailto:">angelicafinanzas@yonekawayasociados.com</a>
    </p>
    <p class="text">
      Nos reservamos el derecho de efectuar en cualquier momento modificaciones
      o actualizaciones al presente aviso de privacidad, para la atención de
      novedades legislativas, políticas internas o nuevos requerimientos para la
      prestación u ofrecimiento de nuestros servicios o productos.
    </p>
    <p class="text">
      Estas modificaciones estarán disponibles al público a través de los
      siguientes medios:
    </p>
    <ul>
      <li class="text">Anuncios visibles en nuestros establecimientos;</li>
      <li class="text">
        O se las haremos llegar al último correo electrónico que nos hayan
        proporcionado.
      </li>
    </ul>
    <p class="text">
      Será responsabilidad de nuestros clientes revisar este Aviso de
      Privacidad, para el caso de actualización o modificación del mismo, si a
      su interés compete; el que no estén enterados de las modificaciones a éste
      Aviso de Privacidad no será responsabilidad de Yonekawa y Asociados, S.A.
      de C.V.
    </p>
    <p class="text">
      La falta de manifestación de inconformidad por parte de nuestros clientes
      respecto a los términos y condiciones previstos de éste Aviso de
      Privacidad, representa su adhesión, consentimiento y autorización al mismo
      en todos sus términos.
    </p>
    <p class="text">
      Si usted considera que su derecho de protección de datos personales ha
      sido lesionado por alguna conducta de nuestros empleados o de nuestras
      actuaciones o respuestas, presumen que en tratamiento de sus datos
      personales existe alguna violación a las disposiciones previstas en la Ley
      Federal de Protección de Datos Personales en Posesión de los Particulares,
      podrá interponer la queja o denuncia correspondiente ante el IFAI, para
      mayor información visite
      <a href="http://www.ifai.org.mx">www.ifai.org.mx</a>
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
